import React, { createContext, useEffect, useMemo, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spinner, Grid } from '@prometheus/components';
import {
  SpinnerWidgetContainer,
  BaseInfoWrapper,
  ListHeaderPrimary,
  TabsNavigationNew,
} from '@prometheus/features';
import {
  IndexInterface,
  InitStorageInterface,
  ModuleContextInterface,
  RootSettingsInterface,
} from '@prometheus/types';

import { EEConfiguration } from './components';
import { tabs } from './Admin.config';
import { Databases } from './components/Databases/Databases';
import { useDispatch } from 'react-redux';
import { setBreadcrumbs } from '@prometheus/redux';
import { VocabularyManagement } from './components/VocabularyManagement/VocabularyManagement';
import { EnviromentsList } from './components/Enviroments';
import { Vaults } from './components/Vaults';

export const ModuleContext = createContext<ModuleContextInterface<any>>(null);

export const Admin: React.FC<IndexInterface<any>> = props => {
  const { path, title, rootSettings } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [root, setRoot] = useState<RootSettingsInterface>(rootSettings);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!rootSettings) {
      setRoot({
        rootPath: path,
        rootTitle: title,
      });
    }

    dispatch(
      setBreadcrumbs([
        {
          name: t('breadcrumbs.admin'),
          path: '',
        },
      ])
    );
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <SpinnerWidgetContainer>
        <Spinner size={32} />
      </SpinnerWidgetContainer>
    );
  }

  return (
    <ModuleContext.Provider value={{ ...props, rootSettings: root }}>
      <Grid container flexDirection="column" minHeight="calc(100vh - 50px)">
        <BaseInfoWrapper>
          <ListHeaderPrimary
            iconName="admin"
            title={t('modules.administration.header')}
          />
          <TabsNavigationNew tabs={tabs()} withRouting />
        </BaseInfoWrapper>
        <Routes>
          <Route
            index
            element={
              <>
                <Navigate to="databases" replace />
              </>
            }
          />
          <Route path="databases/*" element={<Databases root={root} />} />
          <Route path="ee-config/*" element={<EEConfiguration root={root} />} />
          <Route
            path="environments/*"
            element={<EnviromentsList root={root} />}
          />
          <Route
            path="vocabulary/*"
            element={<VocabularyManagement root={root} />}
          />
          <Route path="vaults/*" element={<Vaults root={root} />} />
        </Routes>
      </Grid>
    </ModuleContext.Provider>
  );
};
